<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单记录
  -->
  <div class="pb50">
    <div class="product-content">
      <!--基本信息-->
      <div class="table-wrap" style="margin-left:20px">
        <div class="common-form mt16">订单记录</div>
        <el-timeline>
          <el-timeline-item v-for="(item, index) in detail.orderLog" :key="index" :timestamp="item.time" :type="item.type"
            placement="top">
            <template v-if="item.image" slot="content">
              <div>
                <img v-if="item.image" :src="'data:image/png;base64,' + item.image" alt="暂无图片" width="100" height="100">
                <p>{{ item.value }}</p>
              </div>
            </template>
            <template v-else>
              <p>{{ item.value }}</p>
            </template>
            <!-- <el-card>
              <p>{{ item.value }}</p>
              <img v-if="item.image" :src=" 'data:image/png;base64,'  + item.image" alt="暂无图片" width="100" height="100">
            </el-card> -->
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  props: ["detail"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      activities: []
    };
  },
  mounted() { },
  methods: {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/refund/part/record.vue